import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import BannerImageDesktop from "~/assets/promo-credito-ideal-desktop.webp";
import BannerImageMobile from "~/assets/promo-credito-ideal-mobile.png";

const FORM_URL = "https://forms.gle/hKQKg8mXQP8wo5xW8";

// Banner promocional do formulário público: não vira AppDialog (spec §2.2, item 15).
const BannerModal = ({ open, setOpen, handleClose, isMobile }) => {
  const onClose = (e) => {
    if (typeof handleClose === "function") handleClose(e);
    if (typeof setOpen === "function") setOpen(false);
  };
  const openForm = () => window.open(FORM_URL);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" PaperProps={{ sx: { position: "relative" } }}>
      <IconButton aria-label="Fechar" onClick={onClose} sx={{ position: "absolute", top: 8, right: 8, bgcolor: "rgba(255,255,255,.85)", "&:hover": { bgcolor: "#fff" } }}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: { xs: 1, sm: 2 } }}>
        <Box
          component="img"
          src={isMobile ? BannerImageMobile : BannerImageDesktop}
          alt="Crédito ideal para médicos — Antecipe"
          onClick={openForm}
          sx={{ width: "100%", height: "auto", cursor: "pointer", display: "block" }}
        />
      </DialogContent>
      <DialogActions sx={{ flexDirection: { xs: "column", sm: "row" }, justifyContent: "center", gap: 1.5, px: 3, pb: 2.5 }}>
        <Button variant="contained" onClick={openForm} sx={{ minWidth: 200 }}>Receber meu crédito</Button>
        {isMobile && (
          <Button variant="outlined" color="inherit" onClick={onClose} sx={{ minWidth: 200, ml: "0 !important" }}>Ignorar meu crédito</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default BannerModal;
